import {
    RadioGroup,
    FormControlLabel,
    Radio,
    FormHelperText
} from "@mui/material";
import JText from "components/common/DText";
import DText from "components/common/DText";
import FormLabel from "@mui/material/FormLabel";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";

export default function DRadioGroup({
    name,
    value,
    onChange,
    options = [
        { value: true, child: "Yes" },
        { value: false, child: "No" }
    ],
    disabled = false,
    error = null,
    row = true,
    sm,
    lg,
    xs,
    xlg,
    md = true,
    defaultValue = false,
    label,
    ...rest
}) {
    let size = 18;
    if (xs) size = 12;
    if (sm) size = 14;
    if (lg) size = 20;
    if (xlg) size = 24;

    const optionValues = options.map((opt) => String(opt.value));
    const normalizedValue =
        value !== undefined && value !== null ? String(value) : null;

    const currentValue = optionValues.includes(normalizedValue)
        ? normalizedValue
        : String(defaultValue);

    const handleChange = (e) => {
        const selectedStr = e.target.value;
        const matchedOption = options.find(
            (opt) => String(opt.value) === selectedStr
        );
        // fall back to the raw string if no match is found (shouldn't happen)
        if (onChange) {
            console.log("selectedStr", { onChange });
            onChange(matchedOption ? matchedOption.value : selectedStr);
        }
    };

    return (
        <>
            {/*{label && <FormLabel id={`${label}-label`}>{label}</FormLabel>}*/}
            <GridContainer alignItems="center" spacing={2}>
                {label && <GridItem xs>{label}</GridItem>}
                <GridItem>
                    <RadioGroup
                        row={row}
                        value={currentValue}
                        onChange={handleChange}
                        {...rest}
                    >
                        {options.map((opt) => (
                            <FormControlLabel
                                key={String(opt.value)}
                                value={String(opt.value)}
                                control={
                                    <Radio
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                fontSize: size
                                            }
                                        }}
                                    />
                                }
                                label={
                                    <DText md={md} sm={sm} lg={lg} xlg={xlg}>
                                        {opt.child}
                                    </DText>
                                }
                                disabled={disabled}
                            />
                        ))}
                    </RadioGroup>
                    {error && <FormHelperText error>{error}</FormHelperText>}
                </GridItem>
            </GridContainer>
        </>
    );
}
